import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ExternalPropertyCardSkeleton = () => {
  return (
    <div className="w-full xs:w-[370px] h-[512px] border border-[#D9D9D9] rounded-[10px] p-[10px]">
      <Skeleton height={260} width="100%" borderRadius={0} />
      <div className="mt-5">
        <div className="px-[10px]">
          <Skeleton height={30} width="90%" />
          <div className="mt-3">
            <Skeleton height={20} width="60%" />
          </div>
          <div className="flex items-center space-x-[11px] mt-[16px]">
            <Skeleton height={25} width={90} />
            <Skeleton height={25} width={90} />
            <Skeleton height={25} width={90} />
          </div>
        </div>
        <hr className="h-[1px] bg-[#D9D9D9] my-5" />
        <div className="flex items-end justify-between px-[10px]">
          <Skeleton height={30} width={150} />
          <Skeleton height={30} width={100} />
        </div>
      </div>
    </div>
  );
};

export default ExternalPropertyCardSkeleton;
